// Multiple Choice Fragen für S&T Brain Trainer
// 20 Fragen pro Fach = 100 Fragen insgesamt

export const QUIZ_CONFIG = {
  timeLimit: 30, // Sekunden pro Frage
  questionsPerSubject: 20,
  totalQuestions: 100
};

// NTG - Naturwissenschaftliche und technische Grundlagen (20 Fragen)
export const NTG_QUIZ = [
  {
    id: 1,
    question: "Wie lautet die Formel für das Ohmsche Gesetz?",
    options: ["U = R × I", "P = U × I", "W = F × s", "E = m × c²"],
    correct: 0
  },
  {
    id: 2,
    question: "Welche Einheit hat die elektrische Leistung?",
    options: ["Volt (V)", "Ampere (A)", "Watt (W)", "Ohm (Ω)"],
    correct: 2
  },
  {
    id: 3,
    question: "Was ist die SI-Einheit für Druck?",
    options: ["Newton", "Pascal", "Joule", "Watt"],
    correct: 1
  },
  {
    id: 4,
    question: "Welche Frequenz hat Wechselstrom in Deutschland?",
    options: ["60 Hz", "50 Hz", "100 Hz", "25 Hz"],
    correct: 1
  },
  {
    id: 5,
    question: "Was beschreibt der Wirkungsgrad?",
    options: ["Nutzenergie / Zugeführte Energie", "Kraft × Weg", "Masse × Beschleunigung", "Spannung × Strom"],
    correct: 0
  },
  {
    id: 6,
    question: "Wie berechnet man das Drehmoment?",
    options: ["M = F × r", "M = m × v", "M = P × t", "M = U × I"],
    correct: 0
  },
  {
    id: 7,
    question: "Was ist ein Halbleiter?",
    options: ["Material mit konstantem Widerstand", "Material das nur unter bestimmten Bedingungen leitet", "Perfekter Isolator", "Supraleitender Stoff"],
    correct: 1
  },
  {
    id: 8,
    question: "Welche Aggregatzustände gibt es?",
    options: ["Fest, flüssig, gasförmig", "Kalt, warm, heiß", "Leicht, mittel, schwer", "Dünn, dick, kompakt"],
    correct: 0
  },
  {
    id: 9,
    question: "Was ist die Einheit der Frequenz?",
    options: ["Sekunde", "Meter", "Hertz", "Newton"],
    correct: 2
  },
  {
    id: 10,
    question: "Wie groß ist die Erdbeschleunigung ungefähr?",
    options: ["9,81 m/s²", "10,5 m/s²", "8,5 m/s²", "11 m/s²"],
    correct: 0
  },
  {
    id: 11,
    question: "Was ist ein Transformator?",
    options: ["Wandelt Gleichstrom in Wechselstrom", "Wandelt Wechselspannung um", "Speichert elektrische Energie", "Erzeugt Strom"],
    correct: 1
  },
  {
    id: 12,
    question: "Welches Material ist ein guter elektrischer Leiter?",
    options: ["Gummi", "Kupfer", "Glas", "Kunststoff"],
    correct: 1
  },
  {
    id: 13,
    question: "Was ist der pH-Wert von neutralem Wasser?",
    options: ["0", "7", "14", "1"],
    correct: 1
  },
  {
    id: 14,
    question: "Was beschreibt die Dichte?",
    options: ["Masse pro Volumen", "Volumen pro Masse", "Kraft pro Fläche", "Weg pro Zeit"],
    correct: 0
  },
  {
    id: 15,
    question: "Welche Wärmeübertragungsart funktioniert auch im Vakuum?",
    options: ["Wärmeleitung", "Konvektion", "Wärmestrahlung", "Keine"],
    correct: 2
  },
  {
    id: 16,
    question: "Was ist eine Diode?",
    options: ["Lässt Strom nur in eine Richtung fließen", "Verstärkt Strom", "Speichert Energie", "Wandelt Licht in Strom"],
    correct: 0
  },
  {
    id: 17,
    question: "Wie viele Phasen hat Drehstrom?",
    options: ["1", "2", "3", "4"],
    correct: 2
  },
  {
    id: 18,
    question: "Was misst ein Thermoelement?",
    options: ["Druck", "Temperatur", "Strom", "Spannung"],
    correct: 1
  },
  {
    id: 19,
    question: "Was ist Korrosion?",
    options: ["Erwärmung von Metall", "Zerstörung durch chemische Reaktion", "Verformung unter Druck", "Magnetisierung"],
    correct: 1
  },
  {
    id: 20,
    question: "Was besagt der Energieerhaltungssatz?",
    options: ["Energie kann erzeugt werden", "Energie kann vernichtet werden", "Energie kann nur umgewandelt werden", "Energie ist immer konstant null"],
    correct: 2
  }
];

// BWH - Betriebswirtschaftliches Handeln (20 Fragen)
export const BWH_QUIZ = [
  {
    id: 1,
    question: "Was sind fixe Kosten?",
    options: ["Kosten die mit der Produktion steigen", "Kosten die konstant bleiben", "Kosten für Material", "Kosten für Energie"],
    correct: 1
  },
  {
    id: 2,
    question: "Was ist der Deckungsbeitrag?",
    options: ["Erlös minus variable Kosten", "Erlös minus fixe Kosten", "Gewinn minus Steuern", "Umsatz minus Rabatt"],
    correct: 0
  },
  {
    id: 3,
    question: "Was bedeutet ROI?",
    options: ["Return on Investment", "Rate of Income", "Ratio of Interest", "Revenue of Industry"],
    correct: 0
  },
  {
    id: 4,
    question: "Was ist die Break-Even-Analyse?",
    options: ["Gewinnmaximierung", "Ermittlung der Gewinnschwelle", "Kostenminimierung", "Umsatzprognose"],
    correct: 1
  },
  {
    id: 5,
    question: "Was zeigt die ABC-Analyse?",
    options: ["Alphabetische Sortierung", "Klassifizierung nach Wert/Bedeutung", "Produktqualität", "Mitarbeiterleistung"],
    correct: 1
  },
  {
    id: 6,
    question: "Was ist Just-in-Time?",
    options: ["Schnelle Lieferung", "Materiallieferung bei Bedarf", "Zeitmanagement", "Arbeitszeitmessung"],
    correct: 1
  },
  {
    id: 7,
    question: "Was bedeutet PDCA?",
    options: ["Plan-Do-Check-Act", "Price-Demand-Cost-Analysis", "Product-Design-Control-Audit", "Process-Data-Collection-Archive"],
    correct: 0
  },
  {
    id: 8,
    question: "Was ist Liquidität?",
    options: ["Gewinnspanne", "Zahlungsfähigkeit", "Kreditwürdigkeit", "Umsatzwachstum"],
    correct: 1
  },
  {
    id: 9,
    question: "Was zeigt eine Bilanz?",
    options: ["Nur Gewinn", "Vermögen und Kapital zu einem Stichtag", "Nur Schulden", "Monatliche Einnahmen"],
    correct: 1
  },
  {
    id: 10,
    question: "Was ist Outsourcing?",
    options: ["Insourcing", "Auslagerung von Aufgaben", "Personalabbau", "Produktionssteigerung"],
    correct: 1
  },
  {
    id: 11,
    question: "Was ist der Marketing-Mix (4P)?",
    options: ["Product, Price, Place, Promotion", "Plan, Process, People, Profit", "Production, Payment, Personnel, Profit", "Purchase, Price, Production, Promotion"],
    correct: 0
  },
  {
    id: 12,
    question: "Was ist Kaizen?",
    options: ["Japanische Kampfkunst", "Kontinuierliche Verbesserung", "Qualitätsprüfung", "Produktionstechnik"],
    correct: 1
  },
  {
    id: 13,
    question: "Was ist Cash Flow?",
    options: ["Bargeldbestand", "Überschuss der Einzahlungen über Auszahlungen", "Kreditlinie", "Gewinn vor Steuern"],
    correct: 1
  },
  {
    id: 14,
    question: "Was ist eine SWOT-Analyse?",
    options: ["Stärken, Schwächen, Chancen, Risiken", "System, Workflow, Output, Target", "Sales, Warehouse, Operations, Transport", "Strategy, Work, Organization, Technology"],
    correct: 0
  },
  {
    id: 15,
    question: "Was sind Gemeinkosten?",
    options: ["Direkt zuordenbare Kosten", "Nicht direkt zuordenbare Kosten", "Personalkosten", "Materialkosten"],
    correct: 1
  },
  {
    id: 16,
    question: "Was ist Controlling?",
    options: ["Nur Kostenkontrolle", "Planung, Steuerung und Kontrolle", "Buchhaltung", "Personalführung"],
    correct: 1
  },
  {
    id: 17,
    question: "Was ist die Amortisationszeit?",
    options: ["Lebensdauer eines Produkts", "Zeit bis Investition sich amortisiert", "Garantiezeit", "Produktionszeit"],
    correct: 1
  },
  {
    id: 18,
    question: "Was ist ein Organigramm?",
    options: ["Produktionsplan", "Grafische Darstellung der Organisation", "Finanzplan", "Qualitätshandbuch"],
    correct: 1
  },
  {
    id: 19,
    question: "Was bedeutet Produktivität?",
    options: ["Output geteilt durch Input", "Gewinn geteilt durch Umsatz", "Kosten geteilt durch Erlös", "Arbeitszeit geteilt durch Produkte"],
    correct: 0
  },
  {
    id: 20,
    question: "Was ist Benchmarking?",
    options: ["Vergleich mit den Besten", "Preisvergleich", "Qualitätsprüfung", "Mitarbeiterbewertung"],
    correct: 0
  }
];

// RWH - Rechtsbewusstes Handeln (20 Fragen)
export const RWH_QUIZ = [
  {
    id: 1,
    question: "Wie lange ist die maximale Probezeit?",
    options: ["3 Monate", "6 Monate", "12 Monate", "1 Monat"],
    correct: 1
  },
  {
    id: 2,
    question: "Ab wie vielen Mitarbeitern kann ein Betriebsrat gegründet werden?",
    options: ["3", "5", "10", "20"],
    correct: 1
  },
  {
    id: 3,
    question: "Was regelt das AGG?",
    options: ["Arbeitszeiten", "Diskriminierungsschutz", "Kündigungsfristen", "Urlaubsanspruch"],
    correct: 1
  },
  {
    id: 4,
    question: "Wie lange ist die gesetzliche Ruhezeit zwischen zwei Arbeitstagen?",
    options: ["8 Stunden", "10 Stunden", "11 Stunden", "12 Stunden"],
    correct: 2
  },
  {
    id: 5,
    question: "Wann greift das Kündigungsschutzgesetz?",
    options: ["Sofort", "Nach 3 Monaten", "Nach 6 Monaten", "Nach 12 Monaten"],
    correct: 2
  },
  {
    id: 6,
    question: "Was ist eine Gefährdungsbeurteilung?",
    options: ["Bewertung von Produkten", "Ermittlung von Arbeitsplatzgefahren", "Mitarbeiterbewertung", "Finanzrisikobewertung"],
    correct: 1
  },
  {
    id: 7,
    question: "Was bedeutet CE-Kennzeichnung?",
    options: ["Made in Europe", "Konformität mit EU-Richtlinien", "Qualitätssiegel", "Umweltzeichen"],
    correct: 1
  },
  {
    id: 8,
    question: "Was ist ein Tarifvertrag?",
    options: ["Einzelvertrag zwischen AG und AN", "Vertrag zwischen Gewerkschaft und Arbeitgeberverband", "Betriebsvereinbarung", "Arbeitsvertrag"],
    correct: 1
  },
  {
    id: 9,
    question: "Wie lange ist der gesetzliche Mindesturlaub bei 5-Tage-Woche?",
    options: ["20 Tage", "24 Tage", "30 Tage", "25 Tage"],
    correct: 0
  },
  {
    id: 10,
    question: "Wer trägt die Kosten der Unfallversicherung?",
    options: ["Arbeitnehmer", "Arbeitgeber", "Beide paritätisch", "Der Staat"],
    correct: 1
  },
  {
    id: 11,
    question: "Was ist Mutterschutz?",
    options: ["Urlaubsanspruch", "Schutz für Schwangere und Stillende", "Kündigungsfrist", "Elternzeit"],
    correct: 1
  },
  {
    id: 12,
    question: "Was ist eine Abmahnung?",
    options: ["Kündigung", "Rüge mit Androhung von Konsequenzen", "Gehaltskürzung", "Versetzung"],
    correct: 1
  },
  {
    id: 13,
    question: "Was regelt das Arbeitszeitgesetz maximal pro Tag?",
    options: ["6 Stunden", "8 Stunden (ausnahmsweise 10)", "12 Stunden", "Keine Grenze"],
    correct: 1
  },
  {
    id: 14,
    question: "Was ist das Kreislaufwirtschaftsgesetz?",
    options: ["Wirtschaftsförderung", "Abfallvermeidung und -verwertung", "Finanzregulierung", "Arbeitsmarktgesetz"],
    correct: 1
  },
  {
    id: 15,
    question: "Was sind GHS-Piktogramme?",
    options: ["Firmenlogos", "Gefahrensymbole", "Qualitätszeichen", "Recyclingzeichen"],
    correct: 1
  },
  {
    id: 16,
    question: "Was ist eine Betriebsvereinbarung?",
    options: ["Arbeitsvertrag", "Vereinbarung zwischen AG und Betriebsrat", "Tarifvertrag", "Gesellschaftervertrag"],
    correct: 1
  },
  {
    id: 17,
    question: "Welche Kündigungsarten gibt es?",
    options: ["Nur ordentliche", "Ordentliche und außerordentliche", "Nur fristlose", "Nur betriebsbedingte"],
    correct: 1
  },
  {
    id: 18,
    question: "Was ist ein Sicherheitsdatenblatt?",
    options: ["Arbeitsvertrag", "Dokument mit Infos zu Gefahrstoffen", "Unfallbericht", "Prüfprotokoll"],
    correct: 1
  },
  {
    id: 19,
    question: "Ab wann gilt der Kündigungsschutz bei Betriebsgröße?",
    options: ["Ab 5 MA", "Ab 10 MA", "Ab 20 MA", "Ab 50 MA"],
    correct: 1
  },
  {
    id: 20,
    question: "Wer ist Träger der gesetzlichen Unfallversicherung?",
    options: ["Krankenkasse", "Berufsgenossenschaft", "Rentenversicherung", "Arbeitsagentur"],
    correct: 1
  }
];

// MIKP - Methoden der Information, Kommunikation und Planung (20 Fragen)
export const MIKP_QUIZ = [
  {
    id: 1,
    question: "Was sind die 4 Seiten einer Nachricht nach Schulz von Thun?",
    options: ["Sachinhalt, Selbstoffenbarung, Beziehung, Appell", "Sender, Empfänger, Kanal, Nachricht", "Frage, Antwort, Bestätigung, Abschluss", "Einleitung, Hauptteil, Schluss, Zusammenfassung"],
    correct: 0
  },
  {
    id: 2,
    question: "Was ist Brainstorming?",
    options: ["Kritische Analyse", "Kreativtechnik zur Ideenfindung", "Projektplanung", "Qualitätskontrolle"],
    correct: 1
  },
  {
    id: 3,
    question: "Was zeigt ein Gantt-Diagramm?",
    options: ["Kosten", "Aufgaben und zeitliche Abläufe", "Organisationsstruktur", "Qualitätsdaten"],
    correct: 1
  },
  {
    id: 4,
    question: "Was ist der kritische Pfad?",
    options: ["Kürzester Weg", "Längste Vorgangskette ohne Puffer", "Teuerster Prozess", "Risikoreichster Bereich"],
    correct: 1
  },
  {
    id: 5,
    question: "Was bedeutet SMART bei Zielen?",
    options: ["Schnell, Modern, Aktuell, Real, Top", "Spezifisch, Messbar, Attraktiv, Realistisch, Terminiert", "Simple, Manageable, Achievable, Reliable, Tested", "Strategic, Measured, Approved, Reviewed, Tracked"],
    correct: 1
  },
  {
    id: 6,
    question: "Was ist ein Fishbone-Diagramm?",
    options: ["Organigramm", "Ursache-Wirkungs-Diagramm", "Flussdiagramm", "Balkendiagramm"],
    correct: 1
  },
  {
    id: 7,
    question: "Was ist aktives Zuhören?",
    options: ["Laut antworten", "Konzentriertes Zuhören mit Rückmeldung", "Schnell unterbrechen", "Notizen machen"],
    correct: 1
  },
  {
    id: 8,
    question: "Was ist ein Meilenstein im Projekt?",
    options: ["Tägliches Meeting", "Wichtiger Kontrollpunkt", "Pausenzeit", "Budgetposten"],
    correct: 1
  },
  {
    id: 9,
    question: "Was ist die Eisenhower-Matrix?",
    options: ["Kostenmatrix", "Priorisierung nach Dringlichkeit/Wichtigkeit", "Personalmatrix", "Qualitätsmatrix"],
    correct: 1
  },
  {
    id: 10,
    question: "Was ist das Pareto-Prinzip?",
    options: ["50/50 Regel", "80/20 Regel", "30/70 Regel", "10/90 Regel"],
    correct: 1
  },
  {
    id: 11,
    question: "Was ist ein Projektstrukturplan?",
    options: ["Zeitplan", "Hierarchische Gliederung des Projekts", "Kostenplan", "Personalplan"],
    correct: 1
  },
  {
    id: 12,
    question: "Was ist Moderation?",
    options: ["Vortrag halten", "Neutrale Leitung einer Gruppe", "Protokoll führen", "Entscheidungen treffen"],
    correct: 1
  },
  {
    id: 13,
    question: "Was ist ein Dashboard?",
    options: ["Armaturenbrett im Auto", "Visuelle Übersicht wichtiger Kennzahlen", "Computerprogramm", "Besprechungsraum"],
    correct: 1
  },
  {
    id: 14,
    question: "Was ist die 6-3-5-Methode?",
    options: ["6 Personen, 3 Ideen, 5 Minuten", "6 Fragen, 3 Antworten, 5 Bewertungen", "6 Teams, 3 Runden, 5 Punkte", "6 Schritte, 3 Phasen, 5 Ziele"],
    correct: 0
  },
  {
    id: 15,
    question: "Was ist Feedback?",
    options: ["Kritik", "Rückmeldung zu Verhalten/Leistung", "Lob", "Anweisung"],
    correct: 1
  },
  {
    id: 16,
    question: "Was gehört zu einer guten Präsentation?",
    options: ["Möglichst viel Text", "Einleitung, Hauptteil, Schluss", "Nur Zahlen", "Keine Bilder"],
    correct: 1
  },
  {
    id: 17,
    question: "Was ist ein Protokoll?",
    options: ["Vertrag", "Schriftliche Dokumentation von Besprechungen", "Arbeitsanweisung", "Qualitätshandbuch"],
    correct: 1
  },
  {
    id: 18,
    question: "Was sind Ich-Botschaften?",
    options: ["Egoistische Aussagen", "Aussagen über eigene Gefühle ohne Vorwurf", "Befehle", "Kritik"],
    correct: 1
  },
  {
    id: 19,
    question: "Was ist ein Arbeitspaket?",
    options: ["Werkzeugkoffer", "Kleinste Einheit im Projektstrukturplan", "Dokumentenmappe", "Softwarepaket"],
    correct: 1
  },
  {
    id: 20,
    question: "Was sind die 5 Warum?",
    options: ["5 Fragen an Kunden", "Technik zur Ursachenanalyse", "5 Qualitätskriterien", "5 Projektziele"],
    correct: 1
  }
];

// ZIB - Zusammenarbeit im Betrieb (20 Fragen)
export const ZIB_QUIZ = [
  {
    id: 1,
    question: "Was sind die Führungsstile nach Lewin?",
    options: ["Autoritär, kooperativ, laissez-faire", "Streng, mild, neutral", "Aktiv, passiv, neutral", "Direkt, indirekt, gemischt"],
    correct: 0
  },
  {
    id: 2,
    question: "Wie viele Stufen hat die Bedürfnispyramide nach Maslow?",
    options: ["3", "4", "5", "6"],
    correct: 2
  },
  {
    id: 3,
    question: "Was sind Motivatoren nach Herzberg?",
    options: ["Gehalt und Arbeitsbedingungen", "Leistung, Anerkennung, Verantwortung", "Pause und Urlaub", "Arbeitszeit und Ort"],
    correct: 1
  },
  {
    id: 4,
    question: "Was sind die Teamphasen nach Tuckman?",
    options: ["Start, Mitte, Ende", "Forming, Storming, Norming, Performing", "Planung, Durchführung, Kontrolle", "Idee, Umsetzung, Abschluss"],
    correct: 1
  },
  {
    id: 5,
    question: "Was ist Delegation?",
    options: ["Aufgaben selbst erledigen", "Übertragung von Aufgaben und Verantwortung", "Kontrolle verstärken", "Mitarbeiter entlassen"],
    correct: 1
  },
  {
    id: 6,
    question: "Was ist situatives Führen?",
    options: ["Immer gleich führen", "Führungsstil an Mitarbeiter anpassen", "Nur in Krisen führen", "Führung vermeiden"],
    correct: 1
  },
  {
    id: 7,
    question: "Was ist ein Konflikt?",
    options: ["Harmonie", "Gegensätzliche Interessen/Ziele", "Einigung", "Kompromiss"],
    correct: 1
  },
  {
    id: 8,
    question: "Was ist Mediation?",
    options: ["Meditation", "Vermittlung durch neutralen Dritten", "Gerichtsverfahren", "Kündigung"],
    correct: 1
  },
  {
    id: 9,
    question: "Was ist Coaching?",
    options: ["Sport", "Individuelle Begleitung zur Entwicklung", "Gruppentraining", "Anweisungen geben"],
    correct: 1
  },
  {
    id: 10,
    question: "Was ist Job Rotation?",
    options: ["Entlassung", "Systematischer Arbeitsplatzwechsel", "Beförderung", "Gehaltserhöhung"],
    correct: 1
  },
  {
    id: 11,
    question: "Was passiert in der Storming-Phase?",
    options: ["Harmonie", "Konflikte und Machtkämpfe", "Höchstleistung", "Auflösung"],
    correct: 1
  },
  {
    id: 12,
    question: "Was ist emotionale Intelligenz?",
    options: ["IQ-Test", "Fähigkeit Emotionen wahrzunehmen und zu beeinflussen", "Mathematische Begabung", "Sprachkenntnisse"],
    correct: 1
  },
  {
    id: 13,
    question: "Was ist intrinsische Motivation?",
    options: ["Durch Geld", "Aus der Aufgabe selbst", "Durch Druck", "Durch Belohnung"],
    correct: 1
  },
  {
    id: 14,
    question: "Was ist ein Jahresgespräch?",
    options: ["Tägliches Meeting", "Strukturiertes Gespräch über Leistung und Entwicklung", "Gehaltsverhandlung", "Bewerbungsgespräch"],
    correct: 1
  },
  {
    id: 15,
    question: "Was ist Job Enrichment?",
    options: ["Weniger Aufgaben", "Anreicherung mit anspruchsvolleren Aufgaben", "Gleiche Aufgaben", "Einfachere Aufgaben"],
    correct: 1
  },
  {
    id: 16,
    question: "Was sind Hygienefaktoren nach Herzberg?",
    options: ["Sauberkeit", "Gehalt, Arbeitsbedingungen (verhindern Unzufriedenheit)", "Motivation", "Weiterbildung"],
    correct: 1
  },
  {
    id: 17,
    question: "Was ist Unternehmenskultur?",
    options: ["Firmengebäude", "Gemeinsame Werte und Verhaltensweisen", "Produkte", "Umsatz"],
    correct: 1
  },
  {
    id: 18,
    question: "Was ist Burnout?",
    options: ["Feuer", "Erschöpfungszustand durch Überlastung", "Motivation", "Erfolg"],
    correct: 1
  },
  {
    id: 19,
    question: "Was ist Empowerment?",
    options: ["Kontrolle verstärken", "Übertragung von Entscheidungsbefugnissen", "Entlassung", "Kritik"],
    correct: 1
  },
  {
    id: 20,
    question: "Was macht eine gute Führungskraft aus?",
    options: ["Nur Fachwissen", "Fach-, Sozial-, Methodenkompetenz und Vorbildfunktion", "Nur Autorität", "Nur Freundlichkeit"],
    correct: 1
  }
];

export const ALL_QUIZ_QUESTIONS = {
  ntg: NTG_QUIZ,
  bwh: BWH_QUIZ,
  rwh: RWH_QUIZ,
  mikp: MIKP_QUIZ,
  zib: ZIB_QUIZ
};